<template>
  <CustomUpdateDialog
    dialogTitle="تغییر وضعیت گروه‌بندی"
    dialogId="toggle-lesson-category-dialog"
    :isOkDisabled="isLoading"
    okTitle="تغییر"
    @ok="toggleLessonCategoryIsShow"
  >
    <p>آیا از تغییر وضعیت این گروه‌بندی اطمینان دارید؟</p>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    defaultLessonCategoryId: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async toggleLessonCategoryIsShow() {
      try {
        this.isLoading = true;
        const _this = this;
        let toggleLessonCategoryIsShow = new ToggleLessonCategoryIsShow(_this);
        toggleLessonCategoryIsShow.setRequestParam({
          lessonCategoryId: this.defaultLessonCategoryId,
        });
        await toggleLessonCategoryIsShow.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تغییر کرد!",
                icon: "CheckIcon",
                variant: "success",
                text: "وضعیت گروه‌بندی درس با موفقیت تغییر کرد.",
              },
            });
            this.$emit("refetch");
            this.$bvModal.hide("toggle-lesson-category-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تغییر نکرد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { ToggleLessonCategoryIsShow } from "@/libs/Api/LessonCategory";
</script>
